import axiosPublicClient from "../../../../axiosPublicClient"

const service = async (data) => {
    const result = await axiosPublicClient.post(`/accept-hr-invitation`, data)
    return result.data
}

export default service
